// extracted by mini-css-extract-plugin
export default {"element":"ToggleButton__element___jULU2","icon":"ToggleButton__icon___Eq6HL"};